import { ReactNode, useMemo } from 'react';

import RemoteSwitcherPlugin from '@atlassian/remote-module-loader/plugin-switcher';
import useRemoteModule from '@atlassian/remote-module-loader/use-remote-module';

import { BbEnv, getBbEnv } from 'src/utils/bb-env';

export const useRemoteSwitcherPlugin = () => {
  const environment = getBbEnv() || BbEnv.Development;
  return useMemo(
    () =>
      new RemoteSwitcherPlugin({
        env: environment === 'production' ? 'production' : 'staging',
        variant: 'latest',
      }),
    [environment]
  );
};

export const RemoteSwitcherPreloader = (): ReactNode => {
  const remoteSwitcherPlugin = useRemoteSwitcherPlugin();
  useRemoteModule(remoteSwitcherPlugin);

  return null;
};
